import React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { withRouter, Route, Redirect } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

import { BillField } from 'root/admin/components';

import store from 'root/admin/store';
import { TabMenu, MenuItem } from '@smartplatform/ui';

const menuItems = [
	{
		label: 'Законы',
		id: 'bills',
	},
	{
		label: 'Типы документа',
		id: 'billtypes',
	},

	{
		label: 'Дополнительно',
		id: 'billadditionals',
	},
	{
		label: 'Тематический блок',
		id: 'billthemes',
	},
	{
		label: 'Ответственный комитет',
		id: 'billcommittees',
	},
	{
		label: 'Статус',
		id: 'billstatuses',
	},
];
@observer
export default class Bill extends React.Component {
	@observable tab;

	switchTab = record => {
		this.tab = record.id;
		this.props.history.push(`/admin/bills/${record.id}`);
		store.ui.setPage(record.id);
	};

	render() {
		const rootPath = '/admin/bills';
		if (store.route.path === rootPath) {
			return <Redirect to={`${rootPath}/bills`} />;
		}

		return (
			<div>
				<TabMenu>
					{menuItems.map(record => (
						<MenuItem
							key={`category-${record.id}`}
							label={record.label}
							onClick={() => this.switchTab(record)}
							active={store.ui.page === record.id}
						/>
					))}
				</TabMenu>

				<Route exact path={`${rootPath}/bills`} component={() => <List rootPath={rootPath} tabName="bills" />} />
				<Route exact path={`${rootPath}/bills/:id`} component={() => <Edit rootPath={rootPath} tabName="bills" />} />
				<Route
					path={`${rootPath}/billtypes`}
					component={() => <BillField rootPath={rootPath} model="BillType" tabName="billtypes" />}
				/>
				<Route
					path={`${rootPath}/billadditionals`}
					component={() => <BillField rootPath={rootPath} model="BillAdditional" tabName="billadditionals" />}
				/>
				<Route
					path={`${rootPath}/billthemes`}
					component={() => <BillField rootPath={rootPath} model="BillTheme" tabName="billthemes" />}
				/>
				<Route
					path={`${rootPath}/billcommittees`}
					component={() => <BillField rootPath={rootPath} model="BillCommittee" tabName="billcommittees" />}
				/>
				<Route
					path={`${rootPath}/billstatuses`}
					component={() => <BillField rootPath={rootPath} model="BillStatus" tabName="billstatuses" />}
				/>
			</div>
		);
	}
}
